import { PlanDescriptionFragment } from 'src/legacy_graphql'

class Detail {
  detail: string
  innerDetails: Detail[] | undefined
  isIncluded: boolean | undefined
  constructor(
    detail: string,
    innerDetails: Detail[] | undefined,
    isIncluded?: boolean,
  ) {
    this.detail = detail
    this.innerDetails = innerDetails
    this.isIncluded = isIncluded
  }

  static fromObj(obj: Detail): Detail {
    return new Detail(
      obj.detail,
      obj.innerDetails?.map(Detail.fromObj),
      obj.isIncluded,
    )
  }
}

class UpsaleDisplayType {
  title: string
  description: string
  image: string
  btnTitle: string
  constructor(
    title: string,
    description: string,
    image: string,
    btnTitle: string,
  ) {
    this.title = title
    this.description = description
    this.image = image
    this.btnTitle = btnTitle
  }

  static fromObj(obj: UpsaleDisplayType): UpsaleDisplayType {
    return new UpsaleDisplayType(
      obj.title,
      obj.description,
      obj.image,
      obj.btnTitle,
    )
  }
}

class UpsaleInfoType {
  fullUpsale: UpsaleDisplayType
  miniUpsale: UpsaleDisplayType
  constructor(fullUpsale: UpsaleDisplayType, miniUpsale: UpsaleDisplayType) {
    this.fullUpsale = fullUpsale
    this.miniUpsale = miniUpsale
  }

  static fromObj(obj: UpsaleInfoType): UpsaleInfoType {
    return new UpsaleInfoType(
      UpsaleDisplayType.fromObj(obj.fullUpsale),
      UpsaleDisplayType.fromObj(obj.miniUpsale),
    )
  }
}

export class PlanDescription {
  plan: string
  secondaryTitle: string | undefined
  description: string | undefined
  details: Detail[] | undefined
  disclaimer: string | undefined
  isFeatured: boolean | undefined
  isPromotional: boolean | undefined
  order: number | undefined
  purchaseButtonText: string | undefined
  shouldIgnore: boolean | undefined
  saleorVariantId: string | undefined
  upsaleInfo: UpsaleInfoType | undefined

  constructor(
    plan: string,
    secondaryTitle?: string,
    description?: string,
    details?: Detail[],
    disclaimer?: string,
    isFeatured?: boolean,
    isPromotional?: boolean,
    order?: number,
    purchaseButtonText?: string,
    shouldIgnore?: boolean,
    saleorVariantId?: string,
    upsaleInfo?: UpsaleInfoType,
  ) {
    this.plan = plan
    this.secondaryTitle = secondaryTitle
    this.description = description
    this.details = details
    this.disclaimer = disclaimer
    this.isFeatured = isFeatured
    this.isPromotional = isPromotional
    this.order = order
    this.purchaseButtonText = purchaseButtonText
    this.shouldIgnore = shouldIgnore
    this.saleorVariantId = saleorVariantId
    this.upsaleInfo = upsaleInfo
  }

  static fromObj(obj: PlanDescription): PlanDescription {
    return new PlanDescription(
      obj.plan,
      obj.secondaryTitle,
      obj.description,
      obj.details?.map(Detail.fromObj),
      obj.disclaimer,
      obj.isFeatured,
      obj.isPromotional,
      obj.order,
      obj.purchaseButtonText,
      obj.shouldIgnore,
      obj.saleorVariantId,
      obj.upsaleInfo ? UpsaleInfoType.fromObj(obj.upsaleInfo) : undefined,
    )
  }
}

export class PlansDescription {
  id: string
  description: PlanDescription

  constructor(id: string, description: PlanDescription) {
    this.id = id
    this.description = description
  }

  static fromPlansDescriptionFragment(
    fragment: PlanDescriptionFragment,
  ): PlansDescription {
    try {
      const descriptionObj = JSON.parse(fragment.description)
      return new PlansDescription(
        fragment.id,
        PlanDescription.fromObj(descriptionObj),
      )
    } catch (e) {
      return new PlansDescription(fragment.id, new PlanDescription('Failed'))
    }
  }
}
